import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useHistory } from 'react-router-dom';
import logo from '../../asses/img/parkingl.png'
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { FaHome } from 'react-icons/fa';
import { URL_EMPLOYEE } from '../../constans/servidor';
import TableComponent from '../../components/BManual/Buscador';
import FormularioComponen from '../../components/BManual/Formulario';
import FormularioComponenCM from '../../components/BManual/FormularioCargaMasiva';
import * as ROUTES from '../../constans/rutas';

const ConveniosPage = () => 
{
  const [ventana, setVentana] = useState(1);
  const history = useHistory();

  return (

    <>
      <Container className="contendor-Principal">
        <Row>
          <Col className='cont_logo' xs={12} sm={12} md={12} lg={12} xl={12}>
            <img className='logo' src={logo}></img>
            <p className="texto-slogan">Gestion de Facturas Puntos de Servicio</p>
          </Col>

        </Row>
        <Row className="justify-content-end ">
          <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '15px' }} className='cont_logo' xs={12} sm={12} md={6} lg={4} xl={4}>
            <Button style={{ marginRight: '10px' }} variant="primary" onClick={() => history.push(ROUTES.HOME)}>
              <FaHome size={20} style={{ marginRight: '5px' }} />HOME
            </Button>
          </Col>
        </Row>
        <Row className="justify-content-end mbottom-20 menu">
          <Col className={ventana === 1 ? "menu_items2" : "menu_items"} xs={2} sm={2} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(1) }}>Buscar</button>
          </Col>
          <Col className={ventana === 2 ? "menu_items2" : "menu_items"} xs={4} sm={4} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(2) }}>Registrar</button>
          </Col>
          <Col className={ventana === 3 ? "menu_items2" : "menu_items"} xs={4} sm={4} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(3) }}>Carga Masiva</button>
          </Col>

        </Row>
      </Container>
      <Container>
        {ventana === 1 ? ( <TableComponent></TableComponent> ) : null}
        {ventana === 2 ? (<FormularioComponen></FormularioComponen>) : null}
        {ventana === 3 ? (<FormularioComponenCM></FormularioComponenCM>) : null}
      </Container>
    </>
  )
}
export default ConveniosPage;